import { useOutletContext } from "react-router-dom";
import { Reveal, useSeo } from "@/components/site/Motion";
import { ContactForm } from "@/components/site/ContactForm";

export default function JournalContact() {
  const { journal } = useOutletContext();
  useSeo(`Contact · ${journal.title}`);
  return (
    <div data-testid="contact-page">
      <Reveal>
        <p className="eyebrow mb-5">About · Contact</p>
        <h1 className="font-display text-5xl sm:text-6xl leading-[1.02] mb-6">Contact</h1>
        <p className="text-lg text-[var(--ink-muted)] max-w-2xl mb-12">Questions about submissions, peer review or the journal? Write to the {journal.abbr} editorial office.</p>
      </Reveal>
      <Reveal delay={0.1}><ContactForm journal={journal.slug} /></Reveal>
    </div>
  );
}
